import { tv } from '@/libs/tv'
import type { ComponentProps } from 'react'

const containerStyles = tv({
	base: [
		'grid',
		'[--pi:calc(--spacing(8.5)-0.25rem)]',
		'[--c-max-w:(--spacing(180))]',
		'[--b-max-w:(--spacing(240))]',
		'[--bs:calc((var(--b-max-w)-var(--c-max-w))/2)]',
		'grid-cols-[[full-width-start]_minmax(var(--pi),1fr)_[breakout-start]_minmax(0,var(--bs))_[content-start]_min(100%-(var(--pi)*2),var(--c-max-w))_[content-end]_minmax(0,var(--bs))_[breakout-end]_minmax(var(--pi),1fr)_[full-width-end]]',
		'[&>*:not(.breakout,.full-width)]:col-[content]',
		'[&>*:is(.full-width)>:not(.full-width,.breakout)]:col-[content] [&>*:is(.full-width)]:grid [&>*:is(.full-width)]:grid-cols-[inherit] [&>*:is(.full-width)]:col-[full-width]',
		'[&>*:is(.breakout)]:col-[breakout]',
	],
})

type ContainerProps = ComponentProps<'div'>

const Container = ({ className, ...props }: ContainerProps) => {
	return <div className={containerStyles({ class: className })} {...props} />
}

export { Container }
